import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import AppEntry from './components/AppEntry';
import MarketingRedirect from './components/MarketingRedirect';
import RequireAuth from './components/RequireAuth';
import AppLayout from './components/layouts/AppLayout';
import PublicLayout from './components/layouts/PublicLayout';
import FocusLayout from './components/layouts/FocusLayout';
import InviteLayout from './components/layouts/InviteLayout';
import Document from './pages/Document';
import UploadDocument from './pages/UploadDocument';
import Integration from './pages/Integration';
import ApiReference from './pages/ApiReference';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConfirmEmail from './pages/ConfirmEmail';
import Profile from './pages/Profile';
import DocumentList from './pages/DocumentList';
import SignLink from './pages/SignLink';
import PostHogPageView from './components/analytics/PostHogPageView';
import PostHogUserSync from './components/analytics/PostHogUserSync';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <PostHogPageView />
          <PostHogUserSync />
          <Routes>
          <Route path="/" element={<AppEntry />} />
          <Route path="/about" element={<MarketingRedirect to="/about" />} />
          <Route path="/contact" element={<MarketingRedirect to="/contact" />} />
          <Route path="/privacy" element={<MarketingRedirect to="/about#privacy" />} />
          <Route path="/terms" element={<MarketingRedirect to="/about#terms" />} />
          <Route path="/pricing" element={<MarketingRedirect to="/pricing" />} />

          <Route element={<InviteLayout />}>
            <Route path="/s" element={<SignLink />} />
            <Route path="/s/:token" element={<SignLink />} />
          </Route>

          <Route element={<PublicLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
          </Route>

          <Route element={<RequireAuth />}>
            <Route element={<AppLayout />}>
              <Route
                path="/documents"
                element={
                  <div className="container mx-auto flex h-full min-h-0 w-full flex-col px-3 pb-3 pt-3 md:px-4 md:py-6">
                    <DocumentList />
                  </div>
                }
              />
              <Route
                path="/upload"
                element={
                  <div className="container mx-auto w-full flex-1 px-3 pb-4 pt-3 md:px-4 md:py-6">
                    <UploadDocument />
                  </div>
                }
              />
              <Route
                path="/integration"
                element={
                  <div className="container mx-auto flex-1 px-4 py-6">
                    <Integration />
                  </div>
                }
              />
              <Route
                path="/api-reference"
                element={
                  <div className="container mx-auto flex-1 px-4 py-6">
                    <ApiReference />
                  </div>
                }
              />
              <Route
                path="/profile"
                element={
                  <div className="container mx-auto flex-1 px-4 py-6">
                    <Profile />
                  </div>
                }
              />
            </Route>

            <Route element={<FocusLayout />}>
              <Route path="/document" element={<Document />} />
            </Route>
          </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
